import { Component, Inject, Injector, OnInit } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';

@Component({
    selector: 'fi-sms-state-root',
    templateUrl: './sms-state-root.component.html',
    standalone: false,
})
export class FiSmsStateRootComponent extends TabsModuleBase implements OnInit {
    constructor(
        private injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.tabs = [
            {
                Title: this.appTextService.get('sms_module_name'),
                Sref: FiStateNames.SMS.List,
                AddState: FiStateNames.SMS.Add,
            },
        ];

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.SMS.Costs)) {
            this.tabs.push({
                Title: this.appTextService.get('sms.costs_title'),
                Sref: FiStateNames.SMS.Costs,
            });
        }

        super.updateSelectedTabFromState();
    }
}
